import { useEffect, useRef } from "react";
import { resumeBgMusic } from "../utils/gameAudio";

const PREP_BG = "prep_bg";

/**
 * Loop Prep Bg on player and spectator screens for the same stretches the host does.
 * Stays quiet during the start-session countdown, wheel countdown, and building-the-wheel music.
 */
export default function useHolPrepBg({
  sounds,
  playLoop,
  stopBgMusic,
  prepOn,
  countdownEndsAt,
  wheelPhase,
  suppressed,
}) {
  const playLoopRef = useRef(playLoop);
  const stopRef = useRef(stopBgMusic);
  const startedRef = useRef(false);

  useEffect(() => {
    playLoopRef.current = playLoop;
  }, [playLoop]);

  useEffect(() => {
    stopRef.current = stopBgMusic;
  }, [stopBgMusic]);

  const enabled =
    !!prepOn &&
    !suppressed &&
    !countdownEndsAt &&
    wheelPhase !== "building" &&
    wheelPhase !== "countdown";

  useEffect(() => {
    if (!enabled) {
      if (startedRef.current) {
        startedRef.current = false;
        stopRef.current();
      }
      return;
    }
    if (startedRef.current) return;
    if (!sounds?.[PREP_BG]?.audio_url) return;
    startedRef.current = true;
    playLoopRef.current(PREP_BG);
  }, [enabled, sounds]);

  useEffect(() => {
    if (!enabled) return undefined;
    const retry = () => {
      if (startedRef.current) resumeBgMusic();
    };
    window.addEventListener("pointerdown", retry);
    return () => window.removeEventListener("pointerdown", retry);
  }, [enabled]);

  useEffect(() => () => {
    if (!startedRef.current) return;
    startedRef.current = false;
    stopRef.current();
  }, []);
}
